/**
 * Created by vladislav on 03.09.2019
 */

const Lantern = function (mission) {
    this.mission = mission;

    this.load();
};

Lantern.prototype.isActive = function (level) {
    return !level || level.isRegular();
};

Lantern.getMaxStreak = function () {
    return 3;
};

Lantern.prototype.save = function () {
    this.mission.result = 0;
    this.mission.update(this.streak);
};

Lantern.prototype.load = function () {
    this.streak = this.mission.result;
    this.savedStreak = this.streak;
};

Lantern.prototype.getCurrentStreak = function () {
    return this.savedStreak;
};

Lantern.prototype.incStreak = function () {
    this.streak = Math.min(this.savedStreak + 1, Lantern.getMaxStreak());
    this.savedStreak = this.streak;

    this.save();
};

Lantern.prototype.onChangeOutcome = function (outcome) {
    if (outcome === GameBase.OUTCOME_GAVEUP) {
        this.streak = this.savedStreak;
    } else if (outcome === GameBase.OUTCOME_VICTORY) {
        this.streak = this.savedStreak;
    } else if (outcome === GameBase.OUTCOME_LOST) {
        this.previousStreak = this.savedStreak;
        this.streak = 0;
        this.savedStreak = 0;
    }

    this.save();
};

Lantern.prototype.onStart = function () {
    this.savedStreak = this.streak;
    this.streak = 0;
    this.save();
};

Lantern.prototype.listAfterStartActions = function () {
    if (!cleverapps.config.features.includes("lantern_start")) {
        return [];
    }

    const streak = this.streak;
    const actions = [
        function (f) {
            Game.currentGame.field.showLantern(streak);
            Game.currentGame.counter.setTimeout(f, 300);
        },

        function (f) {
            ComboBooster.afterStartAction({
                amount: 3,
                lantern: true
            }, f);
        },

        function (f) {
            MovesBooster.afterStartAction({
                amount: 3,
                lantern: true
            }, f);
        },

        function (f) {
            MultiColorBooster.afterStartAction({
                amount: 1,
                lantern: true
            }, f);
        }
    ];

    return streak === 0 ? [] : actions.slice(0, streak + 1);
};

Lantern.Get = function () { 
    const lanternMission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LANTERN);
    return lanternMission && lanternMission.logic.lantern;
};

Lantern.IsActive = function (level) {
    const lantern = Lantern.Get();
    return lantern && lantern.isActive(level);
};

Lantern.GetStreak = function (level) {
    const lantern = Lantern.Get();
    return lantern && lantern.isActive(level) && lantern.streak > 0 ? lantern.streak : 0;
};

Lantern.GetCurrentStreak = function (level) {
    const lantern = Lantern.Get();
    return lantern && lantern.isActive(level) && lantern.savedStreak > 0 ? lantern.savedStreak : 0;
};

Lantern.GetPreviousStreak = function (level) {
    const lantern = Lantern.Get();
    return lantern && lantern.isActive(level) && lantern.previousStreak > 0 ? lantern.previousStreak : 0;
};

Lantern.GetBoosterBonus = function (level, booster) {
    const lantern = Lantern.Get();
    const boosters = cleverapps.boosters.listBoostersBefore();
    const index = boosters.indexOf(booster);
    if (lantern && lantern.isActive(level) && lantern.getCurrentStreak() > index) {
        return 1;
    }
    return 0;
};

Lantern.listAfterStartActions = function (level) {
    const lantern = Lantern.Get();
    if (!lantern || !lantern.isActive(level)) {
        return [];
    }

    return lantern.listAfterStartActions(level);
};